import Vue from 'vue';

// Create a new event bus instance
export const EventBus = new Vue();
